import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function AuthAction() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleActionCode = async () => {
      try {
        // URLからクエリパラメータを取得
        const queryParams = new URLSearchParams(location.search);
        const mode = queryParams.get("mode");
        const actionCode = queryParams.get("oobCode");

        if (!mode) {
          throw new Error("モードが指定されていません");
        }

        if (!actionCode) {
          throw new Error("アクションコードが見つかりません");
        }

        // モードに応じた処理を行う
        switch (mode) {
          case "verifyEmail":
            // メール確認モードの場合は、専用ページにリダイレクト
            navigate(`/auth/action/emailverify${location.search}`);
            break;
          case "resetPassword":
            // パスワードリセットモードの場合は、リセットページにリダイレクト
            navigate(`/auth/action/passwdreset${location.search}`);
            break;
          default:
            throw new Error(`不明なモード: ${mode}`);
        }
      } catch (err) {
        console.error("アクションの処理中にエラーが発生しました:", err);
        setError(
          err instanceof Error ? err.message : "不明なエラーが発生しました",
        );
      } finally {
        setLoading(false);
      }
    };

    handleActionCode();
  }, [location, navigate]);

  if (loading && !error) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          mt: 4,
        }}
      >
        <CircularProgress />
        <Typography variant="body1" sx={{ mt: 2 }}>
          処理中...
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ mt: 4, textAlign: "center" }}>
        <Typography variant="h5" color="error" gutterBottom>
          エラーが発生しました
        </Typography>
        <Typography variant="body1">{error}</Typography>
      </Box>
    );
  }

  return null;
}
